import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { useWindowSize } from '../../../../hooks/useWindowResize';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './OpeningListLoader.module.scss';

const OpeningListLoader = ({ background }) => {
  const size = useWindowSize();
  const isMobile = size.width <= 600;

  return (
    <div className={background ? styles.loaderWrapper : styles.loaderContainer}>
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <Skeleton circle width={40} height={40} />
        </div>
        <div className={styles.textWrapper}>
          <div className={styles.titleWidth}>
            <Skeleton height={16} />
          </div>
          <div className={styles.locationWidth}>
            <Skeleton width={134} height={8} />
          </div>
          <div className={styles.bottomItems}>
            <Skeleton borderRadius={16} width={isMobile ? 50 : 65} height={isMobile ? 16 : 22} />
            <Skeleton borderRadius={16} width={isMobile ? 50 : 65} height={isMobile ? 16 : 22} />
            <Skeleton borderRadius={16} width={isMobile ? 50 : 65} height={isMobile ? 16 : 22} />
          </div>
        </div>
        <div className={styles.lineWrapper}>
          <Skeleton width={isMobile ? 80 : 134} height={8} />
        </div>
      </div>
    </div>
  );
};

export default OpeningListLoader;
